import _classCallCheck from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
/* eslint-disable consistent-return */
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import checkStandardConditions from './check-standard-conditions';
import checkTotalQuantity from './check-total-quantity';
import checkTotalWeight from './check-total-weight';
import Condition from './condition';
import checkTotalSpend from './check-total-spend';
import { getSpecialSettings, orderProductsForDiscountPrecedence } from '../utilities';

// Sort individual conditions equal to itemToConsiderLast's id at the bottom so other conditions will be satisfied first
var sortConditions = function sortConditions(conditions, itemToConsiderLast) {
  var _$reduce = _.reduce(conditions || [], function (lists, currentCondition) {
      if ((currentCondition === null || currentCondition === void 0 ? void 0 : currentCondition.productId) !== (itemToConsiderLast === null || itemToConsiderLast === void 0 ? void 0 : itemToConsiderLast.id)) {
        lists[0].push(currentCondition);
        return lists;
      }
      lists[1][(currentCondition === null || currentCondition === void 0 ? void 0 : currentCondition.weight) !== (itemToConsiderLast === null || itemToConsiderLast === void 0 ? void 0 : itemToConsiderLast.weight) ? "unshift" : "push"](currentCondition);
      return lists;
    }, [[], []]),
    _$reduce2 = _slicedToArray(_$reduce, 2),
    topConditions = _$reduce2[0],
    bottomConditions = _$reduce2[1];
  return [].concat(_toConsumableArray(topConditions), _toConsumableArray(bottomConditions));
};
var ConditionsManager = /*#__PURE__*/function () {
  function ConditionsManager(bogoCalcsData, bogoSpecial, items, globalSpecialsSettings) {
    var _bogoSpecial$bogoCond, _bogoSpecial$itemsFor, _bogoSpecial$discount, _bogoSpecial$discount2, _bogoSpecial$totalQua, _bogoSpecial$totalWei, _bogoSpecial$totalSpe;
    _classCallCheck(this, ConditionsManager);
    this.bogoCalcsData = bogoCalcsData;
    this.bogoSpecial = bogoSpecial;
    this.conditions = _.map(bogoSpecial === null || bogoSpecial === void 0 ? void 0 : bogoSpecial.bogoConditions, function (condition) {
      return new Condition(condition, bogoCalcsData, bogoSpecial, items);
    });
    this.logicOperator = (_bogoSpecial$bogoCond = bogoSpecial.bogoConditionLogicOperator) !== null && _bogoSpecial$bogoCond !== void 0 ? _bogoSpecial$bogoCond : 'and';
    this.items = items;
    this.itemsForAPrice = (_bogoSpecial$itemsFor = bogoSpecial.itemsForAPrice) !== null && _bogoSpecial$itemsFor !== void 0 ? _bogoSpecial$itemsFor : {
      enabled: false
    };
    this.discountBundle = (_bogoSpecial$discount = bogoSpecial.discountBundle) !== null && _bogoSpecial$discount !== void 0 ? _bogoSpecial$discount : {
      enabled: false
    };
    this.discountToCart = (_bogoSpecial$discount2 = bogoSpecial.discountToCart) !== null && _bogoSpecial$discount2 !== void 0 ? _bogoSpecial$discount2 : {
      enabled: false
    };
    this.previous = {
      satisfied: false,
      satisfiers: {}
    };
    this.satisfied = false;
    this.satisfiers = {};

    // prefer the specials discount settings before falling back to global settings
    this.specialsSettings = getSpecialSettings(bogoSpecial, globalSpecialsSettings);
    this.totalQuantity = (_bogoSpecial$totalQua = bogoSpecial.totalQuantity) !== null && _bogoSpecial$totalQua !== void 0 ? _bogoSpecial$totalQua : {
      enabled: false
    };
    this.totalWeight = (_bogoSpecial$totalWei = bogoSpecial.totalWeight) !== null && _bogoSpecial$totalWei !== void 0 ? _bogoSpecial$totalWei : {
      enabled: false
    };
    this.totalSpend = (_bogoSpecial$totalSpe = bogoSpecial.totalSpend) !== null && _bogoSpecial$totalSpe !== void 0 ? _bogoSpecial$totalSpe : {
      enabled: false
    };
    this.evaluate({});
  }
  _createClass(ConditionsManager, [{
    key: "evaluate",
    value: function evaluate(_ref) {
      var _this$itemsForAPrice, _this$totalSpend, _this$totalWeight, _this$totalQuantity;
      var itemToConsiderLast = _ref.itemToConsiderLast,
        pendingRewardsSatisfiers = _ref.pendingRewardsSatisfiers,
        itemsOverride = _ref.itemsOverride;
      this.previous = {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
      var items = itemsOverride !== null && itemsOverride !== void 0 ? itemsOverride : this.items;
      if (itemsOverride) {
        // if there is an itemsOverride we want to then make sure those items are also out of the conditions eligible items list for the adv. conditions
        this.reevaluateConditionsEligibleItems({
          items: items
        });
      }
      var satisfied;
      var satisfiers;
      var conditions = itemToConsiderLast && !((_this$itemsForAPrice = this.itemsForAPrice) !== null && _this$itemsForAPrice !== void 0 && _this$itemsForAPrice.enabled) ? sortConditions(this.conditions, itemToConsiderLast) : this.conditions;
      if ((_this$totalSpend = this.totalSpend) !== null && _this$totalSpend !== void 0 && _this$totalSpend.enabled) {
        var _checkTotalSpend = checkTotalSpend({
          bogoCalcsData: this.bogoCalcsData,
          conditions: conditions,
          items: items,
          itemToConsiderLast: itemToConsiderLast,
          itemsForAPrice: this.itemsForAPrice,
          discountBundle: this.discountBundle,
          logicOperator: this.logicOperator,
          pendingRewardsSatisfiers: pendingRewardsSatisfiers,
          specialId: this.bogoSpecial.specialId,
          specialsSettings: this.specialsSettings,
          totalQuantity: this.totalQuantity,
          totalSpend: this.totalSpend
        });
        satisfied = _checkTotalSpend.satisfied;
        satisfiers = _checkTotalSpend.satisfiers;
      } else if ((_this$totalWeight = this.totalWeight) !== null && _this$totalWeight !== void 0 && _this$totalWeight.enabled) {
        var _checkTotalWeight = checkTotalWeight({
          bogoCalcsData: this.bogoCalcsData,
          conditions: conditions,
          items: items,
          itemsForAPrice: this.itemsForAPrice,
          discountBundle: this.discountBundle,
          itemToConsiderLast: itemToConsiderLast,
          logicOperator: this.logicOperator,
          pendingRewardsSatisfiers: pendingRewardsSatisfiers,
          specialId: this.bogoSpecial.specialId,
          specialsSettings: this.specialsSettings,
          totalQuantity: this.totalQuantity,
          totalWeight: this.totalWeight
        });
        satisfied = _checkTotalWeight.satisfied;
        satisfiers = _checkTotalWeight.satisfiers;
      } else if ((_this$totalQuantity = this.totalQuantity) !== null && _this$totalQuantity !== void 0 && _this$totalQuantity.enabled) {
        var _checkTotalQuantity = checkTotalQuantity({
          bogoCalcsData: this.bogoCalcsData,
          conditions: conditions,
          items: items,
          itemsForAPrice: this.itemsForAPrice,
          discountBundle: this.discountBundle,
          itemToConsiderLast: itemToConsiderLast,
          logicOperator: this.logicOperator,
          pendingRewardsSatisfiers: pendingRewardsSatisfiers,
          specialId: this.bogoSpecial.specialId,
          specialsSettings: this.specialsSettings,
          totalQuantity: this.totalQuantity
        });
        satisfied = _checkTotalQuantity.satisfied;
        satisfiers = _checkTotalQuantity.satisfiers;
      } else {
        var _checkStandardConditi = checkStandardConditions({
          conditions: conditions,
          continueCheckingConditionsAfterSatisfied: this.itemsForAPrice.enabled,
          itemToConsiderLast: itemToConsiderLast,
          logicOperator: this.logicOperator,
          pendingRewardsSatisfiers: pendingRewardsSatisfiers,
          items: items,
          itemsForAPrice: this.itemsForAPrice,
          specialsSettings: this.specialsSettings
        });
        satisfied = _checkStandardConditi.satisfied;
        satisfiers = _checkStandardConditi.satisfiers;
      }
      this.satisfied = satisfied;
      this.satisfiers = satisfied ? satisfiers : {};
      return {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
    }
  }, {
    key: "revert",
    value: function revert() {
      var newPrevious = {
        satisfied: this.satisfied,
        satisfiers: this.satisfiers
      };
      this.satisfied = this.previous.satisfied;
      this.satisfiers = this.previous.satisfiers;
      this.previous = newPrevious;
      _.forEach(this.conditions, function (condition) {
        return condition.revert();
      });
    }
  }, {
    key: "reevaluateConditionsEligibleItems",
    value: function reevaluateConditionsEligibleItems(_ref2) {
      var _this = this;
      var items = _ref2.items;
      _.forEach(this.conditions, function (condition) {
        condition.eligibleItems = orderProductsForDiscountPrecedence(_.intersectionBy(items, condition.eligibleItems, 'key'), _this.specialsSettings, _this.itemsForAPrice.enabled ? 'rewards' : 'conditions');
      });
    }
  }]);
  return ConditionsManager;
}();
export default ConditionsManager;